import { Flex } from '@chakra-ui/react';
import { useSearchParams } from 'react-router';
import FilterTag from '@components/FilterTag';

const SelectedFiltersList = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const name = searchParams.get('name');
  const email = searchParams.get('email');

  const onRemoveFilter = (key: string) => {
    const newParams = new URLSearchParams(searchParams);
    newParams.delete(key);
    setSearchParams(newParams);
  };

  return (
    <Flex gap={2}>
      {name && (
        <FilterTag
          label="Nome"
          value={name}
          onRemove={() => onRemoveFilter('name')}
        />
      )}
      {email && (
        <FilterTag
          label="E-mail"
          value={email}
          onRemove={() => onRemoveFilter('email')}
        />
      )}
    </Flex>
  );
};

export default SelectedFiltersList;
